import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';
import { useSplunkLogger } from './splunk-provider';
/**
 * Watches the current route for a :cedantId param and sets it as
 * default metadata on the Splunk logger so every log event includes
 * the cedant field for easy searching.
 *
 * Place this component inside a router context where cedant routes
 * are reachable (e.g. inside AuthenticatedLayout or AppRoutes).
 */
export const SplunkCedantTracker = ({ patterns = ['/treaties/:cedantId/*', '/file/:cedantId/*', '/dlt-details/:cedantId/*'], }) => {
    var _a, _b, _c, _d, _e, _f;
    const logger = useSplunkLogger();
    // Try each pattern to find a cedantId match
    const match0 = useMatch((_a = patterns[0]) !== null && _a !== void 0 ? _a : '');
    const match1 = useMatch((_b = patterns[1]) !== null && _b !== void 0 ? _b : '');
    const match2 = useMatch((_c = patterns[2]) !== null && _c !== void 0 ? _c : '');
    const cedantId = (_f = (_e = (_d = match0 === null || match0 === void 0 ? void 0 : match0.params.cedantId) !== null && _d !== void 0 ? _d : match1 === null || match1 === void 0 ? void 0 : match1.params.cedantId) !== null && _e !== void 0 ? _e : match2 === null || match2 === void 0 ? void 0 : match2.params.cedantId) !== null && _f !== void 0 ? _f : null;
    useEffect(() => {
        if (cedantId) {
            logger.setDefaultMetadata({ cedant: cedantId });
        }
    }, [cedantId, logger]);
    return null;
};
